import React, { Fragment } from 'react';
import '../loggedOut.css';

const TuesdaySocial = () => {
   return (
    <Fragment>
        <div className="logged-out">
            <section className="service-hero scene scene--hero page-hero">
                <div className="container">
                    <div className="hero-grid">
                        <div className="hero-copy">
                            <h1 className="display-5 mb-4">Tuesday Social</h1>
                            <p className="lead">
                                An adaptable program designed to prioritise socialisation, friendship, and meaningful engagement. Based at the Beyond Community Access Hub in North Plympton, the program offers a variety of activities including community outings, shared meals and cooking, technology and video games, recreational woodwork and crafts, fishing, hiking, and more.
                            </p>
                        </div>
                        <div className="hero-media text-center">
                            <div className="image-shell image-shell--hero">
                                <img
                                    src="/marketing_images/social_tuesday/1_first_picture.png "
                                    alt="Morning structured social activity"
                                    className="img-fluid"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="service-day-overview scene scene--paper story-band">
                <div className="container">
                    <div className="story-card">
                        <div className="row g-5 align-items-center">
                            <div className="col-md-6">
                                <div className="image-shell">
                                    <img
                                        src="/marketing_images/social_tuesday/2_second_pic.png "
                                        alt="Morning structured social activity"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <p>
                                    Running every Tuesday, participants begin the day at the Hub with a structured social activity, followed by a shared meal either at the Hub or as a picnic at a local park or beach.
                                </p>
                                <p className="mb-0">
                                    In the afternoon, participants engage in collaboratively planned activities in the community, such as shopping, fishing, movies, bowling, or other recreational experiences.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="service-activities scene scene--soft py-6">
                <div className="container">
                    <div className="section-head">
                        <p className="mb-0">
                            Examples of activities participants enjoy:
                        </p>
                    </div>

                    <div className="tile-grid">
                        {[
                            { title: "Community Outings", image: "/marketing_images/social_tuesday/community_outings.png" },
                            { title: "Shared Meals & Cooking", image: "/marketing_images/social_tuesday/shared_meals_and_cooking.png" },
                            { title: "Technology & Video Games", image: "/marketing_images/social_tuesday/technology_and_video_games.png" },
                            { title: "Recreational Woodwork & Crafts", image: "/marketing_images/social_tuesday/woodwork_and_crafts.jpg" },
                            { title: "Fishing & Hiking", image: "/marketing_images/social_tuesday/fishing_and_hiking.png" },
                            { title: "Movies, Bowling & Social Recreation", image: "/marketing_images/social_tuesday/movies_bowling_and_social_rec.jpg" },
                        ].map((activity) => (
                            <div className="tile-card" key={activity.title}>
                                <div className="image-shell image-shell--card">
                                    <img
                                        src={activity.image}
                                        alt={activity.title}
                                        className="img-fluid"
                                    />
                                </div>
                                <p className="mt-3 mb-0">{activity.title}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="service-team scene scene--paper story-band">
                <div className="container">
                    <div className="story-card">
                        <div className="row align-items-center g-5">
                            <div className="col-md-6 order-2 order-md-1">
                                <p>
                                    Participants are encouraged to contribute ideas for future sessions, fostering ownership, planning skills, and teamwork.
                                </p>
                                <p className="mb-0">
                                    The program is delivered by a dedicated team of support workers committed to creating a fun, inclusive, and socially engaging environment, where participants can build friendships, confidence, and social skills in a supportive setting.
                                </p>
                            </div>
                            <div className="col-md-6 order-1 order-md-2 text-center">
                                <div className="image-shell">
                                    <img
                                        src="/marketing_images/social_tuesday/3_last_pic.png"
                                        alt="Support workers leading social activities"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </Fragment>
);

}

export default TuesdaySocial;
